import './TwitterAuth.scss';

import { FC, useContext, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { AppContext } from 'components/AppContext/AppContext';
import { ConnectionStatus } from 'models/ConnectionStatus';
import { LogLevel } from 'models/LogLevel';
import { SocialAccount, SocialConnectionType } from 'models/Social/SocialAccount';
import { Button } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';

interface TwitterAuthProps {
  onTokenAcquired: (response: SocialAccount) => Promise<void>;
}

const TwitterAuth: FC<TwitterAuthProps> = ({ onTokenAcquired }) => {
  const { configRepo, selectedProjectId, sendLog } = useContext(AppContext);
  const { user } = useAuth0();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const qp = Object.fromEntries(params);

  useEffect(() => {
    if (
      qp.connectionType &&
      qp.screenName &&
      qp.userId &&
      qp.token &&
      qp.secret &&
      qp.connectionType === SocialConnectionType.Twitter
    ) {
      const socialAccount: SocialAccount = {
        projectId: selectedProjectId!,
        blabberJaxUserId: user!.sub!,
        socialAccountName: qp.screenName,
        connectionType: SocialConnectionType.Twitter,
        socialAccountUserId: qp.userId,
        token: qp.token,
        tokenSecret: qp.secret,
        connectionStatus: ConnectionStatus.OK,
        tokenExpiresIn: null,
      };

      const fetchData = async () => {
        await onTokenAcquired(socialAccount);
        navigate(window.location.pathname, {
          replace: true,
        });
      };
      fetchData().catch((e) => {
        sendLog(e.message, LogLevel.error, e);
      });
    }
  }, []);

  // AuthorizeAsync
  const handleClick = async () => {
    const url = `${
      configRepo!.PUBLISH_API_BASE_URI
    }/api/TwitterAuth?projectId=${selectedProjectId}&userId=${encodeURI(user!.sub!)}`;

    window.location.href = url;
  };

  if (!selectedProjectId) {
    return <span style={{ fontStyle: 'italic' }}>Loading...</span>;
  }
  return (
    <Button
      variant="primary"
      onClick={handleClick}
      style={{
        backgroundColor: 'rgb(29, 155, 240)',
        borderRadius: 0,
        boxShadow: 'rgb(0 0 0 / 8%) 0px 8px 28px',
        border: '1px solid rgb(29, 155, 240)',
      }}
    >
      <i className="bi bi-twitter-x" /> Login with X
    </Button>
  );
};

export default TwitterAuth;
